import { render, staticRenderFns } from "./FeedbackMessage.vue?vue&type=template&id=12a9da7f"
import script from "./FeedbackMessage.vue?vue&type=script&lang=js"
export * from "./FeedbackMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports